import { useCallback, useState } from 'react'

export function useCustomShare() {
  const [isOpen, setIsOpen] = useState(false)
  const [shareDataDetails, setshareDataDetails] = useState({})

  const openShare = useCallback((data) => {
    setshareDataDetails(data)
  }, [])

  const closeShare = useCallback(() => {
    setIsOpen(false)
  }, [])

  const openShareModal = useCallback(() => {
    setIsOpen(true)
  }, [])
  
  return {
    isOpen,
    shareDataDetails,
    openShare,
    openShareModal,
    closeShare
  }
}
